define( 'toolkit/b-input/b-input', ['toolkit/b-toolkit/b-toolkit'], function(toolkit) {
	'use strict';

	var PREVENT_CODES = {
		'space': 32
	};

	return toolkit.create( 'b-input', {

		init: function () {
			var prevent = this.getData().prevent || [];

			this._previousVal = '';

			prevent = prevent.map(function (name) {
				return PREVENT_CODES[name] || name;
			});

			this.$el.on('change input', function () {
				this._emitChange();
			}.bind(this));

			this.$el.on('focus', function () {
				this.emit('focus', this.$el.val());
			}.bind(this));

			this.$el.on('blur', function () {
				this.emit('blur');
			}.bind(this));

			// сравниваем значения во время нажатия на клавишу -
			// это решает некоторые проблемы
			// 1 случай с submit, если нажимаем на Enter,
			// то на кейдаун сразу срабатывает submit -
			// и в случае ненативной обработки происходит запрос
			// получили ошибку, отобразили ее установив модификатор invalid,
			// на keyup возникает  change и ошибка сразу пропадает, что неверно
			// 2 у нас есть ошибка, нажимаем например на shift, срабатывает change,
			// ошибка пропадает, хотя значение мы не изменили
			this.$el.on('keydown', function (e) {
				if (prevent.includes(e.which)) {
					return false;
				}

				return true;
			}.bind(this));

			//keyup не убирать. IE9 не поддерживает backspace в других событиях
			this.$el.on('keyup', function () {
				this._emitChange();
			}.bind(this));
		},

		/**
		 * В случае если нужно эмитить change вызываем этот метод!
		 *
		 * @private
		 */
		_emitChange: function() {
			var val = this.$el.val();

			if (this._previousVal !== val) {
				this._previousVal = val;

				this.emit('change', val);
			}
		},

		getValue: function () {
			return this.$el.val();
		},

		setValue: function (value) {
			var start, end;

			try{
				start = this.el.selectionStart;
				end = this.el.selectionEnd;
			} catch (e) {

			}

			this.$el.val(value);

			if (
				start !== void 0 &&
				end !== void 0 &&
				document.activeElement === this.$el[0]
			) {
				// сохраняем только нулевую позицию если нужно
				if (this.hasMod('save-zero-position')) {
					if (start === 0 && end === 0) {
						try{
							this.el.setSelectionRange(start, end);
						} catch (e) {

						}
					}
				}
			}
		},

		focus: function () {
			var value = this.getValue(),
				pos = value.length,
				node = this.$el.get(0);

			this.$el.focus();

			if (node.setSelectionRange) {
				node.setSelectionRange(pos, pos);
			}
		},

		/**
		 * Значение при котором происходила последняя валидация
		 */
		previousValidateValue: void 0,

		/**
		 * Метод валидирует поле, используя функцию валидатор
		 */
		validate: function (validator) {
			this.previousValidateValue = this.getValue();
			return validator(this.$el, this.getValue());
		}

	});

});
